import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ValidationMessage = ({className, compactView, dispatch, ...props}) => (
  <span
    className={classNames('validation', {'validation--small': compactView}, className)}
    {...props}
  />
);

ValidationMessage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  compactView: PropTypes.bool.isRequired,
  dispatch: PropTypes.func
};

function mapStateToProps(state) {
  return {
    compactView: state.xl.compactView
  };
}

export default connect(mapStateToProps)(ValidationMessage);



// WEBPACK FOOTER //
// ./components/Form/ValidationMessage.jsx